import { render, staticRenderFns } from "./NoPrizeModal.vue?vue&type=template&id=35f0b4c6&scoped=true"
import script from "./NoPrizeModal.vue?vue&type=script&lang=js"
export * from "./NoPrizeModal.vue?vue&type=script&lang=js"
import style0 from "./NoPrizeModal.vue?vue&type=style&index=0&id=35f0b4c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f0b4c6",
  null
  
)

export default component.exports